import React, { ReactElement, useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
import { toggleLiveMatchLiverModal } from '../../liveMatchSlice';
import { useGetListLiveMutation } from '../../../../services/api/apiProvider';
import { IResponseLive } from '../../../../services/api/models/response/responseLive';
import {
  LeagueLiveType,
  MethodLiveType,
  VoiceLiveType,
  optionGlobal,
} from '../../../../common/constants/globalConstants';
import emptyImage from '../../../../assets/png/liver_mihaishin.png';
import { LiveBlock } from '../../../live/components/LiveBlock/LiveBlock';
import './LiveMatchLiverModal.scss';

const LiveMatchLiverModal = (): ReactElement => {
  const dispatch = useDispatch();
  const isShowLiveMatchLiver = useSelector(
    (state: AppState) => state.liveMatch.isShowLiveMatchLiver,
  );

  const [loading, setLoading] = useState<boolean>();
  const [liveList, setLiveList] = useState<IResponseLive[]>([]);
  const [getListLive] = useGetListLiveMutation();

  useEffect(() => {
    getLivesData();
  }, []);

  const getLivesData = async () => {
    setLoading(true);

    const data = await getListLive({
      numOfPage: optionGlobal.numOfPage,
      numInPage: optionGlobal.numInPage,
      method: MethodLiveType.ATTENTION,
      league: LeagueLiveType.ANY,
      voice: VoiceLiveType.ANY,
    }).unwrap();
    setLiveList(data);
    setLoading(false);
  };

  const renderList = () => {
    if (loading) {
      return (
        <div className="block-group__loading">
          <Spinner
            animation="border"
            style={{ color: 'var(--color-primary)' }}
          />
        </div>
      );
    }
    if (!liveList || liveList.length <= 0) {
      return (
        <div className="block-group__empty">
          <img src={emptyImage} alt="empty-image" />
        </div>
      );
    }

    return liveList.map((live) => {
      return (
        <div key={live.id}>
          <LiveBlock live={live} />
        </div>
      );
    });
  };

  const handleCloseModal = () => {
    dispatch(toggleLiveMatchLiverModal(false));
  };
  return (
    <Modal
      show={isShowLiveMatchLiver}
      backdrop="static"
      keyboard={false}
      scrollable={true}
      onHide={handleCloseModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>指名する相手を選ぶ</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="root-live-match-liver">
          <div className="live-match-search-liver">
            <div className="live-match-search-liver__input">
              <input type="text" />
            </div>
            <div className="live-match-search-liver__btn">キャンセル</div>
          </div>
          <div className="live-match-liver-list">{renderList()}</div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default LiveMatchLiverModal;
